<template>
    <div class="table-wrap">
        <p class="table-top-text">
            <span class="font-main">*</span> 표시는 필수 입력 항목입니다.
        </p>
        <div class="table table-input">
            <table>
                <colgroup>
                    <col style="width:25%;">
                    <col style="width:25%;">
                    <col style="width:25%;">
                    <col style="width:25%;">
                </colgroup>
                <tbody>
                    <tr>
                        <th>이름</th>
                        <td colspan="3" class="left">{{$store.state.myInfoStore.name}}</td>
                    </tr>
                    <tr>
                        <th>휴대전화</th>
                        <td class="left">{{$store.state.myInfoStore.hpNo}}</td>
                        <th>이메일</th>
                        <td class="left">{{$store.state.myInfoStore.email}}</td>
                    </tr>
                    <tr>
                        <th>환자와의 관계</th>
                        <td colspan="3">
                            <div class="radio-wrap">
                                <label  >
                                    <input type="radio" name="test01" id="test01" v-model="params.item1" value="본인" @change="params.item2 = ''">
                                    <span class="radio-btn"></span>
                                    <p>본인</p>
                                </label>
                                <label  >
                                    <input type="radio" name="test01" id="test02" v-model="params.item1" value="보호자">
                                    <span class="radio-btn"></span>
                                    <p>보호자</p>
                                </label>
                                <div class="radio-text">
                                    <input type="text" :disabled="params.item1 !== '보호자'" v-model="params.item2">
                                    <sub>보호자 선택 시 환자명 을 입력해 주세요.</sub>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>건의유형</th>
                        <td colspan="3">
                            <div class="radio-wrap">
                                <label  >
                                    <input type="radio" name="test02" id="test03" v-model="params.item3" value="문의">
                                    <span class="radio-btn"></span>
                                    <p>문의</p>
                                </label>
                                <label  >
                                    <input type="radio" name="test02" id="test04" v-model="params.item3" value="불편사항">
                                    <span class="radio-btn"></span>
                                    <p>불편사항</p>
                                </label>
                                <label  >
                                    <input type="radio" name="test02" id="test05" v-model="params.item3" value="제안 및 건의사항">
                                    <span class="radio-btn"></span>
                                    <p>제안 및 건의사항</p>
                                </label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th><span class="font-main">*</span> 제목</th>
                        <td colspan="3"><input type="text" placeholder="제목을 입력하세요." v-model="params.title"></td>
                    </tr>
                    <tr>
                        <th><span class="font-main">*</span> 내용</th>
                        <td colspan="3">
                            <textarea name="" id="" placeholder="내용을 입력하세요." v-model="params.content"></textarea>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="botton-wrap type01">
        <a href="javascript:;" class="sub-button c-main" @click="cancelArticle">취소</a>
        <a href="javascript:;" class="main-button c-main" @click="insertArticle">등록</a>
    </div>
</template>

<script>
export default {
    props: {
        boardInfo: ''
    },
    data() {
        return {
            params: {
                content: '',
                item1: '본인',
                item3: '문의'
            },
            byteCount: 0
        };
    },
    watch: {
        // 'params.content'(newVal) {
        //     this.checkByteLength(); // 바이트 수 업데이트
        // }
    },
    methods: {
        cancelArticle() {
            if (confirm('글 작성을 취소하시겠습니까?')) {
                this.$router.push({ path: `${this.$route.path.replace('/register', '/list')}` })
            }
        },
        insertArticle() {
            if (!this.params.title || !this.params.content) {
                alert('필수 입력 항목을 모두 입력해 주세요.');
                return;
            }
            if (this.params.item1 == '보호자' && (!this.params.item2 || !this.params.item2.trim())) {
                alert('환자명을 입력해주세요.');
                return;
            }

            if (confirm('글을 등록하시겠습니까?')) {
                var bid = 11

                this.params.item18 = 'R'
                this.params.hospIds = 'H0006,H0007,H0008'
                if(this.$store.getters.getHost == 'H0009') this.params.hospIds = 'H0009'

                this.axios({
                    method: "post",
                    url: this.api.article.insert + bid,
                    headers: { 'Content-type': 'multipart/form-data' },
                    data: this.params
                }).then(response => {
                    alert("글이 등록되었습니다.");
                    this.$router.push({ path: `${this.$route.path.replace('/register', '/list')}` })
                }).catch((err) => {
                    alert('오류가 발생했습니다. 다시 시도해주시길 바랍니다.')
                    location.reload(true);
                });
            }
        },
        checkByteLength() {
            const byteLength = new Blob([this.params.content]).size; // 바이트 수 계산
            this.byteCount = byteLength;

            if (byteLength > 1000) {
                alert('입력 횟수가 초과되었습니다.');
                this.trimContentToLimit(); // 1000 바이트를 넘으면 내용 잘라냄
            }
        },
        trimContentToLimit() {
            let content = this.params.content;
            let byteLength = 0;
            let trimmedContent = '';

            // 바이트 수가 1000을 넘지 않도록 글자를 하나씩 확인하며 잘라냄
            for (let i = 0; i < content.length; i++) {
                let char = content[i];
                byteLength += new Blob([char]).size;
                if (byteLength > 1000) break;
                trimmedContent += char;
            }

            this.params.content = trimmedContent; // 잘린 내용을 다시 적용
            this.byteCount = new Blob([this.params.content]).size; // 바이트 수 갱신
        }
    },
    mounted() {
        // this.checkByteLength(); // 처음 로드될 때 바이트 수 체크
    },
}
</script>

<style scoped></style>
